import React, { useState, useEffect, useRef } from "react";
import Menu from "../../components/Partials/Menu";
import MenuButton from "../../components/Partials/MenuButton";
import Langs from "../../components/Partials/LangsHome";

const HomeHeader = () => {
  const [hidden, setHidden] = useState(true);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const toggleVisibility = () => {
    setHidden((prevHidden) => !prevHidden);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setHidden(true);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="mb-7">
      <a href="#main" className="skip-link">Saltar al contenido principal</a>
      <div className="is-flex is-justify-content-space-between px-6 is-align-items-center">
        <MenuButton ref={buttonRef} onClick={toggleVisibility} isOpen={!hidden} />
        <Menu hidden={hidden} ref={menuRef} />
        <Langs />
      </div>
    </header>
  );
};

export default HomeHeader;